/**
 *  OKJP-国际-个人-基本信息
 */

import React from 'react';

import { FormType, FormErrorType } from '_common/components/Form/FormType';
import {
  checkJP,
  checkJpName,
  checkEnName,
  checkJpPostcode,
  checkJpAddress,
} from '_common/utils/Check';
import { translate } from '_common/utils/language';

function getBase() {
  const template = {
    // 姓名 中文或英文
    firstName: {
      formType: FormType.MULTI_INPUT,
      extend: 0,
      title: translate('jp.verification.name'),
      cleanValue: false,
      input: [
        {
          key: 'lastName',
          formType: FormType.TEXT,
          value: '',
          type: 'text',
          placeholder: '',
          placeholderLeft: translate('jp.verification.firstName'),
          maxLength: 20,
        },
        {
          key: 'firstName',
          formType: FormType.TEXT,
          value: '',
          type: 'text',
          placeholder: '',
          placeholderLeft: translate('jp.verification.lastName'),
          maxLength: 20,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
        {
          type: FormErrorType.OTHER,
          checkError: (val) => {
            return !checkJpName(val) && !checkEnName(val);
          },
          msg: translate('jp.verification.name.check'),
        },
      ],
      bottomTips: [translate('jp.verification.name.tips')],
    },

    // 姓名 片假字
    firstNamePy: {
      formType: FormType.MULTI_INPUT,
      title: translate('jp.verification.namePy'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          key: 'lastNamePy',
          formType: FormType.TEXT,
          value: '',
          type: 'text',
          placeholder: '',
          placeholderLeft: translate('jp.verification.firstName.katakana'),
          maxLength: 20,
        },
        {
          key: 'firstNamePy',
          formType: FormType.TEXT,
          value: '',
          type: 'text',
          placeholder: '',
          placeholderLeft: translate('jp.verification.lastName.katakana'),
          maxLength: 20,
        },
      ],
      bottomTips: [translate('jp.verification.lastName.katakana.tips')],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
        {
          type: FormErrorType.OTHER,
          checkError: (val) => {
            return !checkJP(val);
          },
          msg: translate('jp.verif.pj.errormsg'),
        },
      ],
    },

    // 性别
    sex: {
      formType: FormType.RADIO,
      extend: 0,
      title: translate('jp.verification.sex'),
      cleanValue: false,
      list: [
        {
          id: 0,
          value: 0,
          label: translate('jp.verification.man'),
        },
        {
          id: 1,
          value: 1,
          label: translate('jp.verification.woman'),
        },
      ],
      input: [{}],
    },

    // 个体户
    selfEployed: {
      formType: FormType.RADIO,
      extend: 0,
      title: translate('jp.verification.selfEployed'),
      cleanValue: false,
      list: [
        {
          value: 1,
          label: translate('jp.verification.yes'),
        },
        {
          value: 0,
          label: translate('jp.verification.no'),
        },
      ],
      input: [{}],
    },

    // 生日
    birthDay: {
      formType: FormType.DATE,
      title: translate('jp.verification.birthday'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          placeholder: translate('user.operation.pleaseChoose'),
          maxLength: 200,
          maxDate: new Date().getTime(),
          // 为了防止个人用户随意选择生日导致未成年人问题 设置打开选择框的默认日期浮标
          defaultDate: '2000-01-01',
        },
      ],
    },

    // 国籍
    countryCode: {
      formType: FormType.SELECT,
      title: translate('jp.verification.country'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          placeholder: translate('user.operation.pleaseChoose'),
          maxLength: 200,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    // 居住地
    residenceCode: {
      formType: FormType.RADIO,
      cleanValue: false,
      title: translate('jp.verification.residence'),
      extend: 0,
      list: [
        {
          id: 1,
          value: 1,
          label: translate('jp.verification.japan'),
        },
      ],
      input: [{}],
      bottomTips: [translate('jp.verification.residence.tips')],
    },

    residenceCodeForGuardian: {
      formType: FormType.RADIO,
      cleanValue: false,
      title: translate('jp.verification.residence'),
      extend: 0,
      list: [
        {
          id: 1,
          value: 1,
          label: translate('jp.verification.japan'),
        },
      ],
      input: [{}],
      bottomTips: [translate('jp.verification.residenceforguardian.tips')],
    },

    residenceWithOtherCode: {
      formType: FormType.RADIO,
      cleanValue: false,
      title: translate('jp.verification.residence'),
      extend: 0,
      list: [
        {
          id: 1,
          value: 1,
          label: translate('jp.verification.japan'),
        },
        {
          id: 0,
          value: 0,
          label: translate('jp.verification.not.japan'),
        },
      ],
      input: [{}],
    },

    residenceWithOtherCodeForCorporation: {
      formType: FormType.RADIO,
      cleanValue: false,
      title: translate('jp.comp.residence'),
      extend: 0,
      list: [
        {
          id: 1,
          value: 1,
          label: translate('jp.verification.japan'),
        },
        {
          id: 0,
          value: 0,
          label: translate('jp.verification.not.japan'),
        },
      ],
      input: [{}],
    },

    // 居住国家/地区
    otherCountryCode: {
      formType: FormType.SELECT,
      title: translate('jp.verification.select.country'),
      cleanValue: false,
      extend: 0,
      hidden: true,
      input: [
        {
          placeholder: translate('user.operation.pleaseChoose'),
          maxLength: 200,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    // 居住地非日本住址
    otherLocation: {
      formType: FormType.TEXT,
      title: translate('jp.verification.not.japan.location'),
      cleanValue: false,
      extend: 0,
      hidden: true,
      input: [
        {
          maxLength: 50,
          placeholderRight: '',
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    // 居住地非日本邮编
    otherPostCode: {
      formType: FormType.NUMBER,
      noWheelEvent: true,
      cleanValue: false,
      title: translate('jp.verification.postCode'),
      extend: 0,
      hidden: true,
      input: [
        {
          placeholder: translate('user.inter.please.postCode'),
          maxLength: 50,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    // 邮编
    postCode: {
      formType: FormType.NUMBER,
      noWheelEvent: true,
      cleanValue: false,
      title: translate('jp.verification.postCode'),
      extend: 0,
      input: [
        {
          placeholder: translate('user.inter.please.postCode'),
          maxLength: 50,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
        {
          type: FormErrorType.OTHER,
          checkError: (val) => {
            return !checkJpPostcode(val);
          },
          msg: translate('jp.verification.number.seven'),
        },
      ],
    },

    // 地址数据
    addressData: {
      formType: FormType.MULTI_INPUT,
      title: translate('kyc.address.title'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          key: 'province',
          formType: FormType.TEXT,
          type: 'text',
          value: '',
          placeholder: '',
          maxLength: 20,
          disabled: true,
        },
        {
          key: 'city',
          formType: FormType.TEXT,
          type: 'text',
          placeholder: '',
          value: '',
          maxLength: 20,
          disabled: true,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    // 街道
    street: {
      formType: FormType.TEXT,
      title: translate('kyc.street.title'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          textCreator: translate('user.operation.createOption'),
          placeholder: translate('kyc.street.example'),
          maxLength: 50,
        },
      ],
    },

    // 年收入
    income: {
      formType: FormType.SELECT,
      title: translate('jp.verification.income'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          placeholder: translate('user.operation.pleaseChoose'),
          maxLength: 50,
        },
      ],
      list: [
        {
          value: 0,
          label: translate('jp.verification.income.option0'),
        },
        {
          value: 1,
          label: translate('jp.verification.income.option1'),
        },
        {
          value: 2,
          label: translate('jp.verification.income.option2'),
        },
        {
          value: 3,
          label: translate('jp.verification.income.option3'),
        },
        {
          value: 4,
          label: translate('jp.verification.income.option4'),
        },
        {
          value: 5,
          label: translate('jp.verification.income.option5'),
        },
        {
          value: 6,
          label: translate('jp.verification.income.option6'),
        },
      ],
    },

    // 金融资产
    financialAssets: {
      formType: FormType.SELECT,
      title: translate('jp.verification.financialAssets'),
      cleanValue: false,
      bottomTips: [
        <div
          style={{ maxWidth: '700px', minWidth: '300px', whiteSpace: 'normal' }}
        >
          {translate('jp.verification.financialAssets.tips')}
        </div>,
      ],
      input: [
        {
          placeholder: translate('user.operation.pleaseChoose'),
          maxLength: 50,
        },
      ],
      list: [
        {
          value: 1,
          label: translate('jp.verification.financialAssets.option1'),
        },
        {
          value: 2,
          label: translate('jp.verification.financialAssets.option2'),
        },
        {
          value: 3,
          label: translate('jp.verification.financialAssets.option3'),
        },
        {
          value: 4,
          label: translate('jp.verification.financialAssets.option4'),
        },
        {
          value: 5,
          label: translate('jp.verification.financialAssets.option5'),
        },
        {
          value: 6,
          label: translate('jp.verification.financialAssets.option6'),
        },
      ],
    },

    // 地址
    location: {
      formType: FormType.TEXT,
      title: translate('kyc.detail.title'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          maxLength: 50,
          placeholder: translate('kyc.location.example'),
        },
      ],
      errorData: [
        {
          type: FormErrorType.OTHER,
          checkError: (val) => {
            return !checkJpAddress(val);
          },
          msg: translate('jp.verification.location.errorMsg'),
        },
      ],
    },

    // 地址
    locationWithTips: {
      formType: FormType.TEXT,
      title: translate('kyc.detail.title'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          maxLength: 50,
          placeholder: translate('kyc.location.example'),
        },
      ],
      errorData: [
        {
          type: FormErrorType.OTHER,
          checkError: (val) => {
            return !checkJpAddress(val);
          },
          msg: translate('jp.verification.location.errorMsg'),
        },
      ],
      bottomTips: [
        <p className="warning-hint">
          {translate('jp.verification.location.tips3')}
        </p>,
      ],
    },

    // 在留类型
    residenceType: {
      formType: FormType.RADIO,
      title: translate('jp.verification.residence.type'),
      cleanValue: false,
      extend: 0,
      hidden: true,
      list: [
        {
          value: 1,
          label: '永住者・特別永住者',
        },
        {
          value: 0,
          label: 'その他',
        },
      ],
      input: [
        {
          value: null,
        },
      ],
    },

    // 在留期限
    residenceValidity: {
      formType: FormType.DATE,
      title: translate('jp.verification.residence.expired.time'),
      cleanValue: false,
      extend: 0,
      hidden: true,
      input: [
        {
          placeholder: translate('user.operation.pleaseChoose'),
          maxLength: 200,
          minDate: new Date().getTime(),
        },
      ],
    },

    position: {
      formType: FormType.TEXT,
      title: translate('jp.verification.position'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          placeholder: '',
          maxLength: 50,
        },
      ],
    },

    // 职业
    career: {
      formType: FormType.MULTI_INPUT,
      extend: 0,
      title: translate('jp.verification.job'),
      cleanValue: false,
      input: [
        {
          key: 'careerLvOne',
          formType: FormType.SELECT,
          type: 'text',
          placeholder: translate('user.operation.pleaseChoose'),
          maxLength: 20,
          style: { width: '360px' },
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },

    // 证件号码
    idCard: {
      formType: FormType.TEXT,
      title: translate('jp.verification.idNumber'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          placeholder: translate('jp.verification.idNumber.plh'),
          maxLength: 32,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
        {
          type: FormErrorType.OTHER,
          checkError(val) {
            const regx = /^[A-Za-z0-9]{6,32}$/;
            return !regx.test(val);
          },
          msg: translate('jp.verif.idcard.errormsg'),
        },
        {
          type: FormErrorType.OTHER,
          checkError(val) {
            const regx = /^[A-Za-z]{6,32}$/;
            return regx.test(val);
          },
          msg: translate('jp.verif.idcard.errormsg'),
        },
      ],
    },

    // 有效截止期
    expirationDate: {
      formType: FormType.DATE,
      title: translate('jp.verification.effective.deadline'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          placeholder: translate('jp.verification.effective.deadline.plh'),
          maxLength: 50,
          minDate: new Date().getTime(),
        },
      ],
      bottomTips: [translate('jp.verification.health.id.tips')],
    },

    // 股东类型
    shareType: {
      formType: FormType.RADIO,
      extend: 0,
      title: translate('jp.comp.share.type'),
      cleanValue: false,
      list: [
        {
          value: 0,
          label: translate('jp.person'),
        },
        {
          value: 1,
          label: translate('jp.comp'),
        },
      ],
      input: [
        {
          value: 0,
        },
      ],
    },

    // 持有股份
    shareHoldRate: {
      formType: FormType.NUMBER,
      noWheelEvent: true,
      title: translate('jp.share.hold.num'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          placeholder: '',
          maxLength: 3,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
        {
          type: FormErrorType.OTHER,
          checkError(val) {
            return val > 100;
          },
          msg: translate('jp.shareHoldRate.errormsg'),
        },
      ],
    },

    // 此股东与法人代表的关系
    shareRelation: {
      formType: FormType.TEXT,
      title: translate('jp.share.relation'),
      cleanValue: false,
      extend: 0,
      input: [
        {
          placeholder: '',
          maxLength: 50,
        },
      ],
      errorData: [
        {
          type: FormErrorType.NULL,
        },
      ],
    },
  };
  return template;
}

export default getBase;
